import { buildHref } from "@softmax/web-addresses";
export const creatorFooterLinks = [
  { label: "Docs", href: buildHref({ name: "docs" }) },
  { label: "Privacy", href: buildHref({ name: "privacy" }) },
  { label: "Terms", href: buildHref({ name: "terms" }) },
];
type VersionAddress = {
  name: string;
  id: string;
  returnQuery?: string | null | undefined;
};
function versionSearch({
  id,
  returnQuery,
}: {
  id: string;
  returnQuery?: string | null | undefined;
}) {
  const params = new URLSearchParams({ version: id });

  if (returnQuery) params.set("from", returnQuery);

  return params;
}
export function creatorVersionHref({
  name,
  id,
  section = "runs",
  returnQuery,
}: VersionAddress & {
  section?: "runs" | "checks";
}) {
  const params = versionSearch({
    id,
    returnQuery,
  });

  if (section === "checks") params.set("section", section);

  return buildHref({
    name: "coworldManage",
    coworldName: name,
    search: params,
  });
}
export function creatorRunHref({
  name,
  id,
  requestId,
  returnQuery,
}: VersionAddress & {
  requestId: string;
}) {
  return buildHref({
    name: "coworldRun",
    coworldName: name,
    requestId,
    search: versionSearch({
      id,
      returnQuery,
    }),
  });
}
export function creatorNewRunHref({ name, id, returnQuery }: VersionAddress) {
  return buildHref({
    name: "coworldNewRun",
    coworldName: name,
    search: versionSearch({
      id,
      returnQuery,
    }),
  });
}
